import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { label: 'Início', href: '#inicio' },
    { label: 'Sobre', href: '#sobre' },
    { label: 'Cardápio', href: 'https://playmenu.app/public/index.php?r=buteco-do-baiano&from=admin', external: true },
    { label: 'Sabores', href: '#sabores' },
    { label: 'Ambiente', href: '#ambiente' },
    { label: 'Galeria', href: '#galeria' },
    { label: 'Localização', href: '#localizacao' },
    { label: 'Contato', href: '#contato' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#inicio"
            className="flex items-center gap-2 md:gap-3 font-heading text-xl md:text-2xl font-bold tracking-tight whitespace-nowrap transition-colors duration-500"
          >
            <img
              src="https://public.readdy.ai/ai/img_res/d9c10758-95b7-4141-835c-255c39595ae7.png"
              alt="Logo Buteco do Baiano"
              className="h-10 w-auto md:h-12"
            />
            <span className={scrolled ? 'text-brown-900' : 'text-white'}>Buteco do Baiano</span>
          </a>

          <div className="hidden lg:flex items-center gap-1">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-all duration-300 whitespace-nowrap ${
                  scrolled
                    ? 'text-brown-700 hover:text-yellow-600 hover:bg-cream-200/50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="https://wa.me/5585987413961?text=Olá!%20Vim%20pelo%20site%20do%20Buteco%20do%20Baiano%20e%20gostaria%20de%20mais%20informações."
              target="_blank"
              rel="noopener noreferrer"
              className={`px-5 py-2.5 text-sm font-semibold rounded-full transition-all duration-300 whitespace-nowrap ${
                scrolled
                  ? 'bg-yellow-500 text-white hover:bg-yellow-600 shadow-sm'
                  : 'bg-yellow-500 text-white hover:bg-yellow-600'
              }`}
            >
              Reservar Mesa
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-brown-900' : 'text-white'
            }`}
            aria-label="Menu"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-white/98 backdrop-blur-md border-t border-cream-300 shadow-lg animate-slide-down">
          <div className="px-4 py-4 flex flex-col gap-1">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-brown-800 text-sm font-medium rounded-lg hover:bg-cream-200/60 hover:text-yellow-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://wa.me/5585987413961?text=Olá!%20Vim%20pelo%20site%20do%20Buteco%20do%20Baiano%20e%20gostaria%20de%20mais%20informações."
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileOpen(false)}
              className="mt-2 px-5 py-3 bg-yellow-500 text-white text-sm font-semibold rounded-full text-center hover:bg-yellow-600 transition-all"
            >
              Reservar Mesa
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}